import React, { FC } from "react";

interface ImageComponentType {
    caption: string;
    imagelink: string;
}
const ImageComponent: FC<ImageComponentType> = ({ caption, imagelink }) => {
    return (
        <section className="my-8 sm:my-16 sm:my-20 img-component">
            <figure>
                <img src={imagelink} alt="" />
                <figcaption>{caption}</figcaption>
            </figure>
        </section>
    );
};

export default ImageComponent;
